import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Spacer from "../../components/Spacer";
import MainContainer from "../../components/MainContainer";
import { headerDataAdmin } from "../../data/modules/admin-header";
import { useParams } from "react-router-dom";
import PersonalSettingService from "../../services/PersonalSettingService";
import Message from "../tools/Message";
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import { format } from "date-fns";
import CandidatureService from "../../services/CandidatureService";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const OPTION_CNADIDATURE = [
  { label: "Consultant Individuel", value: "Cons_indiv" },
  { label: "Consultant Interne", value: "Cons_int" },
  { label: "Consultant Externe", value: "Cons_ext" },
  { label: "Volontariat", value: "Volontariat" },
];

const INIT_FORM_ERROR = {
  poste_error: null,
  date_debut_error: null,
  date_fin_error: null,
  reference_ami_error: null,
  type_recrutement_error: null,
  desc_error: null,
  id_min_diplom_error: null,
};

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "row",
    maxWidth: 800,
    elevation: 0,
  },
  form: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  labelPosition: {
    float: "left",
  },
  text: {
    width: 370,
  },
}));

function CandidatureAdd(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name_field: "",
    date_start: new Date(),
    date_end: new Date(),
    dateend: "",
    datestart: "",
    descript: "",
    type: "interne",
    desc: "",
    id_min_diplom: null,
  });
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [diplomes, setDiplomes] = useState([]);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const params = useParams();
  const personal_config_id = params.id;
  const navigate = useNavigate();

  useEffect(() => {
    handleFetchDiplome();
    if (personal_config_id) {
      PersonalSettingService.getPersonalSettingsById(personal_config_id).then(
        ({ data: personalSetting }) => {
          setForm({
            name_field: personalSetting.name_field,
            type_field: personalSetting.type_field,
            required: personalSetting.required,
            personal_config_id: personalSetting.personal_config_id,
          });
        }
      );
    }
  }, []);

  const handleFetchDiplome = () => {
    CandidatureService.fetchDiplomeList().then((result) => {
      if (result && result.data) {
        setDiplomes(result.data || []);
      }
    });
  };

  function handleClick() {
    setLoading(true);
    CandidatureService.insert(
      form.name_field,
      form.date_start,
      form.date_end,
      form.desc,
      form.descript,
      form.type || "interne",
      form.id_min_diplom || null
    )
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
          navigate("/list_candidature");
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur",
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  }


  const handleChangedate = (newValue) => {
    const formattedDate = format(newValue, "dd/MM/yyyy");
    setForm({ ...form, date_start: newValue, datestart: formattedDate });
  };

  const handleChangedateend = (newValue) => {
    setForm({
      ...form,
      date_end: newValue,
      dateend: format(newValue, "dd/MM/yyyy"),
    });
  };

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }


  useEffect(() => {
    setFormErrors({
      date_debut_error: form.date_start ? null : "Date de debut requis",
      date_fin_error: form.date_end ? null : "Date de fin requis",
      desc_error: form.desc ? null : "Option requis",
      poste_error: form.name_field ? null : "Nom du poste requis",
      reference_ami_error: null,
      type_recrutement_error: null,
      id_min_diplom_error: null,
    });
  }, [form]);

  return (
    <MainContainer {...headerDataAdmin}>
      {/* <DiplomeRequisAdd
        open={openDiplomeForm}
        onClose={handleOnCloseDiplomeForm}
        onOpen={handleOnOpenDiplomeForm}
      /> */}
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={handleCloseMessage}
      />
      <Grid container item xs={12}>
        <LoadingButton
          loading={loading}
          variant="contained"
          color="error"
          onClick={handleClick}
          style={{ fontWeight: 600 }}
        >
          ENREGISTRER
        </LoadingButton>
      </Grid>
      <Spacer y={2} />
      <Paper className={classes.paper} variant="outlined">
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <label className={classes.labelPosition}>Nom du poste*</label>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              id="outlined-basic"
              size="small"
              label="Nom du poste"
              variant="outlined"
              value={form.name_field}
              name="name_field"
              onChange={handleChange}
              error={formErrors.poste_error}
              helperText={formErrors.poste_error || ""}
            />
          </Grid>
          <Grid item xs={4}>
            <label className={classes.labelPosition}>
              Date de début de la publication *
            </label>
          </Grid>
          <Grid item xs={8}>
            {/* <DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={form.date_start}
                name="date_start"
                onChange={handleChangedate}
                renderInput={(params) =>
                  <TextField {...params} fullWidth variant="outlined" id="date-picker-dialog" size="small" color="primary" error={false} />
                }
              /> */}
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={form.date_start}
                name="date_start"
                onChange={handleChangedate}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    id="date-picker-dialog"
                    size="small"
                    color="primary"
                    error={false}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={4}>
            <label>Date de fin de la publication *</label>
          </Grid>
          <Grid item xs={8}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={form.date_end}
                name="date_end"
                onChange={handleChangedateend}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    id="date-picker-dialog"
                    size="small"
                    color="primary"
                    error={false}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={4}>
            <label className={classes.labelPosition}>Référence AMI *</label>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              id="outlined-basic"
              size="small"
              name="descript"
              value={form.descript}
              onChange={handleChange}
              label="Référence AMI"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={4}>
            <label className={classes.labelPosition}>Type Recrutement *</label>
          </Grid>
          <Grid item xs={8}>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              onChange={(e) => handleChange(e)}
              value={form.type || "interne"}
              name="type"
            >
              <FormControlLabel
                value="interne"
                control={<Radio />}
                label="Interne"
              />
              <FormControlLabel
                value="extene"
                control={<Radio />}
                label="Extene"
              />
            </RadioGroup>
          </Grid>
          <Grid item xs={4}>
            <label className={classes.labelPosition}>
              Option Recrutement *
            </label>
          </Grid>
          <Grid item xs={8}>
            <Autocomplete
              size="small"
              options={OPTION_CNADIDATURE}
              onChange={(e, v) => {
                if (v)
                  handleChange({ target: { name: "desc", value: v.value } });
                else handleChange({ target: { name: "desc", value: null } });
              }}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="desc"
                  error={formErrors.desc_error}
                  helperText={formErrors.desc_error || ""}
                  label="Option"
                  placeholder="Option de candidature"
                />
              )}
              sx={{ flexGrow: 1, mr: 0.5 }}
            />
          </Grid>
          <Grid item xs={4}>
            <label className={classes.labelPosition}>
              Diplome minimum requis
            </label>
          </Grid>
          <Grid item xs={8}>
            <Autocomplete
              size="small"
              onChange={(e, v) =>
                handleChange({
                  target: { name: "id_min_diplom", value: v ? v.id_diplome : null },
                })
              }
              options={diplomes}
              getOptionKey={(option) => option.id_diplome}
              getOptionLabel={(option) => option.label}
              // filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Diplome minimum requis"
                  placeholder="Diplome minimum requis"
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>
    </MainContainer>
  );
}

export default CandidatureAdd;
